export default "__VITE_ASSET__CyZZREMw__"